// extracted by mini-css-extract-plugin
module.exports = {"AdSlotMail__mail":"bgw_a bhu_vf bhu_a bhu_q bhu_k","AdSlotMail__mail--notLoaded":"bgw_b bhu_eu bhu_bj bhu_vu","show-ad-not-loaded":"bgw_c","AdSlotMail__cta":"bgw_e"};